import { Injectable } from '@angular/core';

import { CurrentContextService } from '../../services/current-context/current-context.service';

// eslint-disable-next-line @typescript-eslint/no-var-requires
// const Pusher = require('pusher-js');
import Pusher from 'pusher-js';

@Injectable({
  providedIn: 'root',
})
export class PusherService {
  constructor(private context: CurrentContextService) {}

  public get socket(): any {
    if (this.context.env) {
      return new Pusher(this.context.env?.pusher_key, { encrypted: true });
    }
  }
}
